// Map [Enter] key to work like the [Tab] key
// Daniel P. Clark 2014
// MIT License

import $ from 'jquery'

export const enter_tab ={
  mounted() {
    this.$el.addEventListener('keydown', this.handelKeydown);
  },
  destroyed() {
    this.$el.removeEventListener('keydown', this.handelKeydown);
  },
  methods: {
    handelKeydown(e) {
      // Set self as the current item in focus
      var self = $(':focus'),
        // Set the form by the current item in focus
        form = self.parents('section:eq(0)'),
        focusable;      
      // Array of Indexable/Tab-able items
      focusable = form.find('input,a,select,textarea').filter(':visible');
      function enterKey(){        
        if (e.which !== 13 || self.is('textarea')) { // [Enter] key
          return true;
        }
        let parent = self.parent();
        // when select control menu is expanded
        // if (parent[0].classList.contains('is-focus')) {
        if (parent.length > 0 && parent[0].classList.contains('is-focus') && !self.is('input')) {
          return true;
        }
        // If not a regular hyperlink/button/textarea
        if ($.inArray(self, focusable) 
        && (!self.is('a')) && (!self.is('button'))){
          // Then prevent the default [Enter] key behaviour from submitting the form
          e.preventDefault();
        } // Otherwise follow the link/button as by design, or put new line in textarea

        // when autocomplete and not selected, ignore it.
        if (self.attr('aria-autocomplete') && !self.attr('aria-allow-unselected') && !self.attr('aria-selected')) {
          e.preventDefault();
          return false;
        }

        if (self.is('button')) {
          self.click();
          return false;
        }
        
        // Focus on the next item (either previous or next depending on shift)
        let next = focusable.index(self) + (e.shiftKey ? -1 : 1);
        // disabled 속성이면 다음 컨트롤로 이동
        while(focusable[next] && focusable[next].disabled) {
          e.shiftKey ? next-- : next++;
        }     
        if (focusable[next]) { focusable[next].focus();}
        return false;        
      }
      // We need to capture the [Shift] key and check the [Enter] key either way.
      // if (e.shiftKey) { enterKey() } else { enterKey() }
      enterKey();
    },
    /**
     * jQuery로 다음 컨트롤 이동
     * @param {*} element 
     */
    focusNext(element) {
      let inputs = $(element).parents("form").eq(0).find(":input");   
      let idx = inputs.index($(element).find('input'));   
      if (idx == inputs.length - 1) {
        inputs[0].select()
      } else {
        inputs[idx + 1].focus();
        // inputs[idx + 1].select();
      }
    },
  }
}
